import React from 'react';
import { Drawer } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from 'components/Logo/Logo';
import LogoRavBariah from 'assets/images/Logo.png';
import { ReactComponent as CloseIcon } from 'assets/images/close.svg';
import Button from 'components/Button/Button';
import { useHistory } from 'react-router-dom';
import useTranslations from 'hooks/useTranslations';
import LogoLockerimRavBariah from 'assets/images/logo_lockerim_rav_bariah.png';

import './SideMenu.scss';

const SideMenu = ({ items, onClose, show }) => {
  const history = useHistory();
  const { rcTranslate } = useTranslations();

  const onClickOrderLocker = () => {
    history.push('/onboarding/landing-page');
    onClose();
  };

  return (
    <Drawer className="sideMenu" anchor={'left'} open={show} onClose={onClose}>
      <div className="header">
        <button className="closeIcon" onClick={onClose}>
          <CloseIcon className="header__close-icon" />
        </button>
        <div className="header__logo-wrapper">
          <img
            src={LogoLockerimRavBariah}
            alt="logoRavBariah"
            className="logoImage"
          />
        </div>
      </div>
      <nav className="sideMenu__links-wrapper" aria-label="Side menu links">
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <Link
                className="sideMenu__link"
                to={item.link}
                onClick={onClose}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="order__locker-wrapper">
        <Button
          className="order__locker-button"
          onClick={onClickOrderLocker}
          title={rcTranslate('button.orderLocker')}
        />
      </div>
    </Drawer>
  );
};

export default SideMenu;
